export default __webpack_public_path__ + "static/media/vale.919fd303.png";